<template>
	<div class="pb-30">
		<h1 class="match-header">Match request</h1>
		<md-card class="mt-30">
			<md-card-header class="ask-subject" :style="communityStyle" v-text="$lodash.has(community, 'name') ? community.name + ': ' + ask.subject : ask.subject">
			</md-card-header>
		</md-card>
		<ask-detail class="mt-30" :ask="ask" v-on:chosen="addSeeker" editAsk="true">Ask detail goes here...</ask-detail>
		<md-card class="mt-30">
			<md-card-header>
				<div class="md-title card-header">Current Tags:</div>
				<md-chips class="md-accent" v-model="ask.tags" md-static></md-chips>
				<div class="md-title card-header">Suggested Advisors:
					<md-field>
						<md-input v-model="searchTerms" @keyup.enter="search()" placeholder="Custom Search">
						</md-input>
					</md-field>
				</div>
			</md-card-header>
			<md-card-content>
				<matched-advisors :advisors="advisors" @changed="updateSelected" :ask="ask">Advisors goes here...</matched-advisors>
				<md-ripple>
					<base-interaction-button :interaction="action" @interact="doInteraction">{{ action }}</base-interaction-button>
				</md-ripple>
			</md-card-content>
		</md-card>
		<ask-feedback class="mt-30" :ask="ask">Feedback goes here...</ask-feedback>
		<comments class="mt-30" :ask="ask" section="Comments">Activity log goes here...</comments>
		<activity-log class="mt-30" :ask="ask">Activity log goes here...</activity-log>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import AskDetail from "./AskDetail";
import ActivityLog from "./ActivityLog";
import MultiMemberPicker from "./MultiMemberPicker";
import Comments from "./Comments";
import MatchedAdvisors from "./MatchedAdvisors";
import AskFeedback from "./AskFeedback";
export default {
  components: {
    ActivityLog,
    AskDetail,
    MultiMemberPicker,
    Comments,
    MatchedAdvisors,
    AskFeedback
  },
  data() {
    return {
      api: new API(),
      ask: {},
      action: "match",
      advisors: [],
      searchTerms: "",
      selectedAdvisors: [],
      lastRequestDate: [],
      lastResponseDate: [],
      communityStyle: {
        backgroundColor: "white",
        color: "black"
      },
      community: {},
      createdByMember: {}
    };
  },
  created() {
    this.loadData();
    this.sortComments(this.ask.comments);
    // console.log('dates', this.lastRequestDate, this.lastResponseDate);
  },
  methods: {
    loadData: async function() {
      await this.api.get(`asks/${this.$route.params.ask_id}`).then(ask => {
        this.ask = ask.data;
        this.selectedAdvisors = this.ask.recommendedAdvisors;
        this.api
          .get(`asks/${this.$route.params.ask_id}/smart-match`)
          .then(advisors => {
            this.advisors = advisors.data;
          });
          this.community = this.ask.community;
          if (this.$lodash.has(this.community, 'customSettings')) {
          	this.communityStyle.backgroundColor = this.community.customSettings.primaryColor;
          	this.communityStyle.color = this.community.customSettings.secondaryColor;
          }
      });
    },
    search: async function() {
      await this.api
        .get(
          `asks/${this.$route.params.ask_id}/smart-match?term=${
            this.searchTerms
          }`
        )
        .then(advisors => {
			this.advisors = advisors.data;
        });
    },
    toggle: function(member) {
      if (this.selectedAdvisors.indexOf(member._id) >= 0) {
        this.selectedAdvisors.splice(
          this.selectedAdvisors.indexOf(member._id),
          1
        );
      } else {
        this.selectedAdvisors.push(member._id);
      }
    },
    doInteraction: async function() {
      await this.api
        .post(`asks/${this.ask._id}/${this.action}`, {
          advisors: this.selectedAdvisors
        })
        .then(response => {
          this.$emit("reload");
          this.$router.push(`/`);
        });
    },
    calculate(skills) {
    	var matched = 0;
    	this.ask.tags.forEach((tag, index) => {
    		skills.forEach((skill, i) => {
    			if (tag.toLowerCase() === skill.toLowerCase()) {
    				matched += 1;
    			}
    		})
    	})
    	return Math.round(matched / this.ask.tags.length * 100);
    },
    sortComments: async function(comments) {
    	if (comments) {
	        await comments.sort((a, b) => {
	          return a.when < b.when ? -1 : 1;
	        });
        }
    },
    updateSelected: function(selectedList) {
      this.selectedAdvisors = selectedList;
    },
    getCreatedBy: function() {
      this.createdByMember = this.ask.createdByMemberID;
    },
    addSeeker: function(members) {
      this.ask.createdByMemberID = members[0];
      this.getCreatedBy();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InteractMatch.vue